import { Typography } from "@mui/material"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"

export interface IAppVersionProps extends IAppVersionConnectProps {
  id?: string
  useTrunkedImage?: boolean
  sx?: any
}

export interface IAppVersionConnectProps {
  version: string
}

const AppVersionFn = React.memo(({ id, version, sx }: IAppVersionProps): JSX.Element => {
  return (
    <Typography color="textSecondary" fontSize=".75rem" id={id} sx={{ ...sx }}>
      v{version}
    </Typography>
  )
})

export const AppVersion = connect(
  (state: IRootState): IAppVersionConnectProps => ({
    version: state.ui.config.version
  })
)(AppVersionFn)
